/**
 * Lo que la columna «Utilidad %» de la tabla necesita para editar la utilidad de UN rubro.
 * Quitar la entrada devuelve el rubro a la utilidad general, que es la que no se toca aqui.
 */
export function edicionMargenes(margenes: Record<string, number>, cambiar: (nuevos: Record<string, number>) => void) {
  return {
    cambiados: margenes,
    alCambiar: (codigo: string, fraccion: number) => cambiar({ ...margenes, [codigo]: fraccion }),
    alRestablecer: (codigo: string) => cambiar(Object.fromEntries(Object.entries(margenes).filter(([c]) => c !== codigo))),
  }
}
